var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-onboarding2-attribution"},[_c('Page',{attrs:{"i":8}},[_c('h1',[_vm._v("Last bit")]),_c('span',{staticClass:"c-byline"},[_vm._v(" How did you find us? ")]),_c('FormUser',{on:{"onSubmit":_vm.onSubmit}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }